export default "__VITE_ASSET__um40aBGV__"